import styled from 'styled-components';
import {
  color,
  border,
  space,
  fontSize,
  width,
  display,
  flexbox,
} from 'styled-system';

import { colors } from 'styles/theme';

const Input = styled.input`
  appearance: input;
  display: block;
  width: 100%;
  margin: 0;
  font-family: inherit;

  ${border}
  ${space}
  ${fontSize}
  ${color}
  ${width}
  ${display}
  ${flexbox}

  border: 0;
  outline: 0;
  box-shadow: inset 0px 1px 2px 0px
      ${(props) => (props.error ? colors.red : colors.line)},
    inset 0px 0px 1px 1px ${(props) => (props.error ? colors.red : colors.line)};

  &::placeholder {
    color: ${colors.blueGray};
    opacity: 0.8;
  }
`;

Input.displayName = 'Input';
Input.propTypes = {
  ...border.propTypes,
  ...space.propTypes,
  ...fontSize.propTypes,
  ...color.propTypes,
  ...width.propTypes,
  ...display.propTypes,
};

Input.defaultProps = {
  color: 'blueGray',
  bg: 'inputBg',
  fontSize: 1,
  borderRadius: 2,
  p: 4,
  mb: [2, 4],
};

export default Input;
